@if (data().items && data().items.length) {
  @let context = context$ | async;
  <section class="gallery-layout gallery-layout-8">
    @if (data().items; as items) {
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-xs-12">
            @if (isMiddleOfficeToken$ | async) {
              <app-middle-office-button [type]="'EDIT_GALLERY'" class="middle-office" />
            }
          </div>
          @if (items[0]; as item) {
            <figure class="figure col-lg-6 col-xs-6 item-0">
              @if (item.image; as image) {
                <app-image [image]="image" [size]="{ dw: 588, dh: 760, mh: 203 }" class="img" />
              }
              @if (item.legend; as legend) {
                <figcaption>
                  <hr class="separator" />
                  <p [innerHTML]="legend" class="legend"></p>
                </figcaption>
              }
            </figure>
          }
          @if (items[1]; as item) {
            <figure class="figure col-lg-5 col-lg-offset-1 col-xs-6 item-1">
              @if (item.image; as image) {
                <app-image [image]="image" [size]="{ dw: 486, dh: 625, mh: 203 }" class="img" />
              }
              @if (item.legend; as legend) {
                <figcaption>
                  <hr class="separator" />
                  <p [innerHTML]="legend" class="legend"></p>
                </figcaption>
              }
            </figure>
          }
        </div>
        <div class="row">
          @if (items[2]; as item) {
            <figure class="figure col-lg-12 col-xs-12 item-2">
              @if (item.image; as image) {
                <app-image [image]="image" [size]="{ dw: 1200, dh: 760, mh: 207 }" class="img" />
              }
              @if (item.legend; as legend) {
                <figcaption>
                  <hr class="separator" />
                  <p [innerHTML]="legend" class="legend"></p>
                </figcaption>
              }
            </figure>
          }
          <div class="col-lg-12 col-xs-12 center-xs center-lg">
            @if (context?.virtualUrl) {
              <app-button
                (buttonClicked)="showModal.set(true)"
                [icon]="{ name: 'CHEVRON_RIGHT', position: 'RIGHT', color: 'BLACK' }"
                class="button"
                label="Visite virtuelle du magasin"
                theme="TRANSPARENT_BLACK" />
            }
          </div>
        </div>
      </div>
    }
  </section>
  @if (context?.virtualUrl) {
    <div [class.modal--open]="showModal()" class="modal">
      <div class="modal-content">
        <i (click)="showModal.set(false)" [color]="'WHITE'" [iconName]="'CLOSE_THIN'" [size]="'3rem'" class="icon"></i>
        <iframe
          [src]="context!.virtualUrl! | safeUrl"
          allowfullscreen
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          style="border: 0">
        </iframe>
      </div>
    </div>
  }
}
